// extracted by mini-css-extract-plugin
export default {"resetButton":"qFP5chl","root":"FSJbXUW","item":"Jy3emQf","itemTitle":"i1M8HEv","aside":"wJMZQDY"};